<template>
  <div>
    <div class="flex w-full vx-row no-gutter" style="height: 60px" :style="`background-image: url('/assets/images/pages/login-bg_${appFilename}.jpg')`">
      <div class="vx-col sm:w-1/3 flex items-center flex-col">
        <img :src="`/assets/images/pages/login_${appFilename}.png`" alt="" style="height: 60px" />
      </div>
    </div>
    <div class="flex w-full bg-img vx-row no-gutter" style="background: #F3F3F7">
      <div class="flex w-full justify-center">
        <div class="vx-col sm:w-1/2 m-4 flex items-center flex-col">
          <div class="text-2xl font-bold text-center mt-6 mb-8">
            Escolha sua assinatura agora com<br><span style="color: #f34949">50% de desconto</span>
          </div>

          <div v-for="(plan, index) in plans" :key="plan.id" class="bg-white p-6 rounded-lg shadow border-4 border-primary mb-8 price-card" :class="{'popular': planIdPopular === plan.id, 'price-selected': planId === plan.id}" @click="selectPlan(plan.id)">
            <div class="mb-4 plan_item--badge" v-if="planIdPopular === plan.id">MAIS POPULAR</div>
            <div class="mb-6 call" v-if="index === 0" style="font-size: 12px; font-weight: bold">Para testar o aplicativo e ver como funciona</div>
            <div class="mb-6 call" v-if="index === 1" style="font-size: 12px; font-weight: bold">Para conferir o que está acontecendo agora</div>
            <div class="mb-6 call" v-if="index === 2" style="font-size: 12px; font-weight: bold">Para garantir que não haja problemas</div>
            <div class="mb-6 call" v-if="index > 2" style="font-size: 12px; font-weight: bold">Para ficar sempre na maior tranquilidade</div>
            <div class="flex justify-between">
              <div class="text-xl font-bold uppercase plan-name">{{ plan.name }}</div>
              <div class="text-xl" v-if="plan.interval_unit === 'MONTH'"><span class="fixed-price line-through">{{ plan.discount | money(plan.currency_code) }}</span> <span class="font-bold fixed-price">{{ plan.fixed_price | money(plan.currency_code) }}</span><span class="per-month">/mês*</span></div>
              <div class="text-xl" v-else><span class="font-bold fixed-price">{{ plan.fixed_price | money(plan.currency_code) }}</span></div>
            </div>

            <div class="mt-8 features">
              <div>
                <div style="width: 24px; text-align: center; display: inline-block; font-size: 18px"><i class="far fa-badge-check"></i></div>
                Inclui todos os recursos Premium
              </div>
              <div>
                <div style="width: 24px; text-align: center; display: inline-block; font-size: 18px"><i class="far fa-mobile"></i></div>
                Para todos os dispositivos Android
              </div>
              <div>
                <div style="width: 24px; text-align: center; display: inline-block; font-size: 18px"><i class="far fa-eye-slash"></i></div>
                Modo invisível
              </div>
            </div>

            <div class="mt-8 price">
              <a href="javascript:" @click="next()" class="button block w-full p-4 font-bold rounded text-center text-white">COMPRE JÁ</a>
            </div>
          </div>

          <div class="text-center mb-8 text-sm">
            *Os preços mensais são aplicados nas assinaturas de 1, 3 e 12 meses.<br>
            O preço está com desconto. Nós cobraremos o preço cheio a partir da próxima renovação da assinatura.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      planId: 0,
      planIdPopular: 0,
      plans: [],
      appName: process.env.VUE_APP_NAME,
      appFilename: process.env.VUE_APP_FILENAME,
    };
  },
  mounted() {
    if (!localStorage.getItem('sign-up-email')) {
      this.$router.push('/pages/sign-up');
    } else {
      this.$api
          .get("/api/v1/plans/new-checkout")
          .then((response) => {
            this.plans = response.data.data
            this.planIdPopular = this.plans[2].id
            this.planId = this.plans[2].id
          })
          .catch(error => {
            this.$vs.notify({
              time: 6000,
              text: error.response.data.errors.join("<br>"),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger"
            });
          });
    }
  },
  computed: {},
  methods: {
    next() {
      localStorage.setItem('planId', this.planId)
      this.$router.push('/pages/sign-up/payment');
    },
    back() {
      this.$router.push('/pages/sign-up');
    },
    selectPlan(planId) {
      this.planId = planId
    },
  }
};
</script>

<style>

.price-card {
  cursor: pointer;
  width: 320px;
}

.price, .call, .features, .line-through {
  display: none;
}

.price-card.price-selected {
  padding: 20px 16px !important;
  min-width: 414px;
}

.price-selected .price, .price-selected .call, .price-selected .features {
  display: block;
}

.plan-name, .fixed-price, .per-month {
  font-size: 12px !important;
}

.price-selected .plan-name, .price-selected .fixed-price {
  font-size: 24px !important;
}

.price-selected .per-month {
  margin-left: 4px;
  font-size: 14px !important;
}

.price-selected .line-through {
  display: inline-block;
  font-size: 14px !important;
  margin-right: 4px;
}

.plan_item--badge {
  font-weight: 600;
  font-size: 10px;
  line-height: 13px;
  text-transform: uppercase;
  color: #fff;
  padding: 3px 8px;
  background: #7cb937;
  border-radius: 20px;
  margin-bottom: 8px;
  display: block;
  width: 100px;
  text-align: center;
}

.popular {
  border: 1px solid #7cb937 !important;
  box-shadow: none;
}

.popular.price-selected {
  box-shadow: 0 0 10px rgba(124, 185, 55, .7), 0 1px 5px rgba(0, 0, 0, .25), 0 11px 24px rgba(215, 222, 241, .2) !important;
}

i.far {
  color: #7cb937 !important;
}

.button {
  background: #7cb937 !important;
}
body {
  background: #F3F3F7;
}
</style>
